export enum VideoPixelFormatEnum {
  Yuv420p = 0, // Best for most live streaming. Lower bandwidth usage, good quality, and widely compatible (e.g., YouTube, Twitch).
  Yuv420p10le = 1, // 10-bit color depth. Used in HDR or higher-quality streaming with a small tradeoff in latency. Slightly larger file size but higher color precision.
  Yuv422p = 2, // Better chroma fidelity than yuv420p. Can be used in some professional streaming scenarios but requires more bandwidth.
}

export type VideoPixelFormat =
  | VideoPixelFormatEnum.Yuv420p
  | VideoPixelFormatEnum.Yuv420p10le
  | VideoPixelFormatEnum.Yuv422p;
